import * as React from "react"

const Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24.397}
    height={24.397}
    className="close-icon-black-bg"
    {...props}
  >
    <path
      data-name="Path 214"
      d="M96.2 14a12.2 12.2 0 1 0 12.2 12.2A12.21 12.21 0 0 0 96.2 14zm5.265 16.488-.976.976-4.289-4.289-4.29 4.288-.976-.976 4.289-4.287-4.289-4.29.976-.976 4.29 4.289 4.289-4.289.976.976-4.29 4.29z"
      transform="translate(-84 -14)"
      style={{
        fill: "#6c6c6c",
      }}
    />
  </svg>
)

export default Icon